let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4y93x")).then(() => parcelRequire('hKEgw'));